module.exports = __webpack_public_path__ + "static/media/Flaaffy_gaussian2.a82956d4.png";